export var LoadingStates;
(function (LoadingStates) {
    LoadingStates["NotLoaded"] = "notLoaded";
    LoadingStates["Loading"] = "loading";
    LoadingStates["LoadedSuccess"] = "loadedSuccess";
    LoadingStates["LoadedFail"] = "loadedFail";
})(LoadingStates || (LoadingStates = {}));
//# sourceMappingURL=constants.js.map